/**
 * @info
 *
 * *The "store/vto" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the PDP.

 * *This file*
 * This file outlines "getters". Getters are methods
 * that perform modifications to the state value prior
 * to returning the value to the consuming component.
 */

export default {
  currentGroup: (state) => {
    return state.recommendations[state.activeGroup];
  },
  currentMicroCollection: (state, getters) => {
    return getters.filteredRecommendations[getters.currentMicroCollectionTitle];
  },
  currentMicroCollectionTitle: (state, getters) => {
    if (
      !Boolean(
        getters.filteredRecommendations[state.activeMicroCollectionTitle]
          .length,
      )
    ) {
      let newActiveMicroCollectionTitle = '';
      for (const [title, products] of Object.entries(
        getters.filteredRecommendations,
      )) {
        if (Boolean(products.length)) {
          newActiveMicroCollectionTitle = title;
          break;
        }
      }
      return newActiveMicroCollectionTitle;
    }
    return state.activeMicroCollectionTitle;
  },
  microCollectionTagline: (state, getters) => (title) => {
    const tagMap = new Map();
    let description = '';

    getters.filteredRecommendations[title].forEach((product) => {
      product.tags.forEach((tag) => {
        if (tag.includes(':')) {
          const key = tag.split(':')[0];
          const value = tag.split(':')[1];
          if (tagMap.has(key)) {
            tagMap.set(key, tagMap.get(key).add(value));
          } else {
            const set = new Set();
            set.add(value);
            tagMap.set(key, set);
          }
        }
      });
    });

    tagMap.forEach((value, key) => {
      if (state.filterGroups.includes(key)) {
        if (value.size === 1) {
          description = `${description}, ${value.values().next().value} ${key}`;
        }
      }
    });

    const replaced = description.replace(', ', '');
    return replaced;
  },
  currentProduct: (state, getters) => {
    if (getters.currentMicroCollection === undefined) {
      return {};
    }
    return getters?.currentMicroCollection[state?.activeProductIndex];
  },
  filteredRecommendations: (state, getters) => {
    if (!Boolean(Object.keys(state.activeFilters).length)) {
      return getters.currentGroup;
    }
  
    const matchedProducts = {
      cooler: [],
      lighter: [],
      recommended: [],
      deeper: [],
      warmer: [],
    };
  
    for (const [group, microCollections] of Object.entries(
      state.recommendations,
    )) {
      const filtered = {};
      for (const [microCollection, products] of Object.entries(
        microCollections,
      )) {
        filtered[microCollection] = products.filter((product) => {
          const productCopy = { ...product, filters: { ...product.filters } }; // Create a copy of the product and its filters
          let allFiltersMatch = true;
  
          for (const [key, value] of Object.entries(state.activeFilters)) {
            const found = product.tags.find(tag => tag.includes(`${key}:${value}`));
            if (found) {
              const filterValue = found.split(':')[1];
              productCopy.filters[key] = filterValue; // Modify the copy, not the original
            }
  
            if (!found || productCopy.filters[key] !== value) {
              allFiltersMatch = false;
              break;
            }
          }
          return allFiltersMatch;
        });
      }
      matchedProducts[group] = filtered;
    }
  
    return matchedProducts[state.activeGroup];
  },  
};
